import React from 'react';
import PropTypes from 'prop-types';
import List from '../right-pane/list';

import SenderStatusListItem from './sender-status-list-item';

const DomainsList = ( { domainsData, editMode, onSelection, onEdit } ) => {
    return (
        <List
            listLength={domainsData.length}
            editMode={editMode}
            onEdit={onEdit}
            type="domain"
        >
            {
                domainsData.map( domainData =>
                    ( <SenderStatusListItem
                        item={domainData}
                        key={domainData.name}
                        editMode={editMode}
                        onSelection={onSelection}
                    /> )
                )
            }
        </List>
    );
};

DomainsList.propTypes = {
    domainsData: PropTypes.arrayOf(
        PropTypes.shape( {
            id: PropTypes.string,
            name: PropTypes.string,
        } )
    ),
    editMode: PropTypes.bool,
    onEdit: PropTypes.func,
    onSelection: PropTypes.func,
};

DomainsList.defaultProps = {
    editMode: false,
};

export default DomainsList;
